module.exports = __webpack_public_path__ + "static/media/liveroom_defult_banner2.2b35a1cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom_defult_banner2.png
// module id = 1957
// module chunks = 6